import api from '../../api/api'

const initialOrder = {
    status: 'initial'
}

// initial state
const state = {
	order: Object.assign({}, initialOrder),
  error: {
    updateOrder: null
  },
  status: {
    createOrder: null,
    updateOrder: null,
    cancelBooking: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  createOrder ({ commit, state }, params) {
    commit('setStatus', { createOrder: api.status.PENDING })
    return api.createOrder(params).then((response) => {
      commit('setOrder', response.data.order)
      //commit('booking/setBooking', response.data.booking, {root: true})
      commit('setStatus', { createOrder: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { createOrder: api.status.FAILURE })
    })
  },
  updateOrder ({ commit, state }, params) {
    commit('setStatus', { updateOrder: api.status.PENDING })
    return api.updateOrder(params).then((response) => {
      commit('setOrder', response.data.order)
      commit('booking/setBooking', response.data.booking, {root: true})
      commit('setStatus', { updateOrder: api.status.SUCCESS })
    }).catch((error) => {
      commit('setError', { updateOrder: error.response.data.error })
      commit('setStatus', { updateOrder: api.status.FAILURE })
    })
  },
  cancelBooking ({ commit, state, dispatch }) {
    commit('setStatus', { cancelBooking: api.status.PENDING })
    return api.cancelBooking().then((response) => {
      commit('setStatus', { cancelBooking: api.status.SUCCESS })
      commit('booking/setBooking', {}, {root: true})
      commit('resetOrder')
    }).catch((error) => {
      commit('setStatus', { cancelBooking: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setOrder (state, order) {
    state.order = order;
  },
  setOrderStatus (state, status) {
    state.order.status = status
  },
  setError (state, error) {
    Object.assign(state.error, error)
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  },
  resetOrder (state) {
    state.order = initialOrder
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
